module.exports = __webpack_public_path__ + "static/logo2-white.974d317e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo2-white.png
// module id = 516
// module chunks = 35783957827783